<template>
  <div id="app">
    <div v-if="isMobileOnly">
      <div class="header">
        <img :src="require('@/assets/img/logo.png')" />
      </div>
      <router-view />
    </div>
    <div v-else>Only For Mobile</div>
  </div>
</template>

<script>
import { isMobileOnly } from "mobile-device-detect";

export default {
  data() {
    return {
      isMobileOnly: isMobileOnly,
    };
  },
};
</script>

<style src="@/assets/css/style.css" lang="css"></style>
<style>
#app {
  font-family: Avenir, Helvetica, Arial, sans-serif;
  -webkit-font-smoothing: antialiased;
  -moz-osx-font-smoothing: grayscale;
  text-align: center;
  color: #2c3e50;
}

nav {
  padding: 30px;
}

nav a {
  font-weight: bold;
  color: #2c3e50;
}

nav a.router-link-exact-active {
  color: #42b983;
}
</style>
